import React, { ReactElement } from 'react';
import pluralize from 'pluralize';
import { Button } from '../../../components/Buttons/Button/Button';

import './styles.scss';

export const TrialCountDownBanner = ({
  daysRemaining,
  planName,
  ctaLabel,
  onCtaClick,
}: {
  daysRemaining: number;
  planName: string;
  ctaLabel: string;
  onCtaClick: () => void;
}): ReactElement => {
  return (
    <div className="trial-count-down-banner">
      {daysRemaining > 0 ? (
        <div>
          <strong>{pluralize('day', daysRemaining, true)} left</strong> on your
          free trial of <strong>{planName}</strong>
        </div>
      ) : (
        <div>
          Your <strong>{planName}</strong> trial is about to expire
        </div>
      )}
      <Button label={ctaLabel} colour="cta-pink" onClick={onCtaClick} />
    </div>
  );
};
